module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chat-room-list"
  }, [_c('div', {
    staticClass: "new-chat-btn",
    on: {
      "click": function($event) {
        _vm.showSearch = !_vm.showSearch
      }
    }
  }, [_c('svg', {
    attrs: {
      "width": "20",
      "height": "20",
      "viewBox": "0 0 24 24",
      "fill": "none"
    }
  }, [_c('path', {
    attrs: {
      "d": "M12 5v14M5 12h14",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("Nova Conversa")])]), _vm._v(" "), (_vm.showSearch) ? _c('div', {
    staticClass: "user-search"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchQuery),
      expression: "searchQuery"
    }],
    staticClass: "search-input",
    attrs: {
      "placeholder": "Buscar usuário..."
    },
    domProps: {
      "value": (_vm.searchQuery)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.searchQuery = $event.target.value
      }, _vm.searchUsers]
    }
  }), _vm._v(" "), (_vm.searching) ? _c('div', {
    staticClass: "search-loading"
  }, [_vm._v("Buscando...")]) : _vm._e(), _vm._v(" "), (_vm.searchResults.length > 0) ? _c('div', {
    staticClass: "user-list"
  }, _vm._l((_vm.searchResults), function(user) {
    return _c('div', {
      key: user.id,
      staticClass: "user-item",
      on: {
        "click": function($event) {
          return _vm.startConversation(user)
        }
      }
    }, [_c('div', {
      staticClass: "user-avatar"
    }, [_vm._v(_vm._s(user.initial))]), _vm._v(" "), _c('div', {
      staticClass: "user-info"
    }, [_c('div', {
      staticClass: "user-name"
    }, [_vm._v(_vm._s(user.displayName))]), _vm._v(" "), _c('div', {
      staticClass: "user-email"
    }, [_vm._v(_vm._s(user.email || '-'))])])])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.searchQuery && _vm.searchResults.length === 0 && !_vm.searching) ? _c('div', {
    staticClass: "no-results"
  }, [_vm._v("\n      Nenhum usuário encontrado\n    ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.showSearch) ? _c('div', {
    staticClass: "rooms-header"
  }, [_vm._v("Conversas")]) : _vm._e(), _vm._v(" "), (!_vm.showSearch) ? _c('div', {
    staticClass: "rooms-search"
  }, [_c('div', {
    staticClass: "rooms-search-box"
  }, [_c('svg', {
    staticClass: "rooms-search-icon",
    attrs: {
      "width": "18",
      "height": "18",
      "viewBox": "0 0 24 24",
      "fill": "none"
    }
  }, [_c('path', {
    attrs: {
      "d": "M21 21l-4.3-4.3m1.8-5.2a7 7 0 11-14 0 7 7 0 0114 0z",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.roomQuery),
      expression: "roomQuery"
    }],
    attrs: {
      "placeholder": "Pesquisar conversas..."
    },
    domProps: {
      "value": (_vm.roomQuery)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.roomQuery = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.roomsSafe), function(room) {
    return _c('div', {
      key: room.id,
      staticClass: "room-item",
      on: {
        "click": function($event) {
          return _vm.selectRoom(room.id)
        }
      }
    }, [_c('div', {
      staticClass: "room-avatar"
    }, [_vm._v(_vm._s(room.initial))]), _vm._v(" "), _c('div', {
      staticClass: "room-info"
    }, [_c('div', {
      staticClass: "room-row"
    }, [_c('div', {
      staticClass: "room-name"
    }, [_vm._v(_vm._s(room.displayName))]), _vm._v(" "), (_vm.formatRoomTime(room)) ? _c('div', {
      staticClass: "room-time"
    }, [_vm._v(_vm._s(_vm.formatRoomTime(room)))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "room-last-message"
    }, [_vm._v("\n        " + _vm._s(room.lastMessage && room.lastMessage.content ? room.lastMessage.content : 'Sem mensagens') + "\n      ")])]), _vm._v(" "), (room.unreadCount) ? _c('span', {
      staticClass: "room-badge"
    }, [_vm._v(_vm._s(room.unreadCount))]) : _vm._e()])
  }), _vm._v(" "), (_vm.roomsSafe.length === 0 && !_vm.showSearch) ? _c('div', {
    staticClass: "empty-state"
  }, [_vm._v("\n    Nenhuma conversa. Clique em \"Nova Conversa\" para começar!\n  ")]) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e40a78cc","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/plugins/chat-plugin/components/ChatRoomList.vue
// module id = 2075
// module chunks = 18